module.exports = __webpack_public_path__ + "img/1471585956.52b511fa.jpg";